module.exports = __webpack_public_path__ + "assets/img/8_1352_big.622ba389.jpg";